import React from "react";
import { useNProgress } from "@tanem/react-nprogress";
import LoadingBar from "react-top-loading-bar";

import { useAppContext } from "../context/context";

const TopLoadingBar = () => {
    const { isAnimating }: any = useAppContext();

    const { progress } = useNProgress({ isAnimating });

    // Calculate the color dynamically based on progress
    const progressPercentage = progress * 100;
    const color = progressPercentage <= 30
        ? "#f11946" // Red
        : progressPercentage > 30 && progressPercentage < 70
            ? "#FF5F1F" // Orange
            : "#58e815"; // Green

    return <LoadingBar color={color} progress={progressPercentage} />;
}

export default TopLoadingBar;